import * as Sentry from '@sentry/react';
import { isTokenExpired } from './auth';

export const checkEvent = (event: Sentry.Event): Sentry.ErrorEvent | null => {
  const tokenExpired = isTokenExpired();
  const errorMessage = event?.exception?.values?.[0]?.value ?? '';

  return errorMessage.includes('403') && tokenExpired ? null : (event as Sentry.ErrorEvent);
};
